module.exports = __webpack_public_path__ + "static/Kwera_Credits_Contact-Anna-4628d613f3be3b5e30e6a3c4fb1f5cb3.png";